import PQueue from "p-queue/dist/index.js";

const EventBus = function (prefix) {
    const bus = new WeakMap();
    this.subscribe = (event_name, handler, shared_data) => {
        let rx_queue = new PQueue({concurrency: 1});
        let event_handler = ({detail}) => {
            rx_queue.add(() => handler(detail, shared_data));
        };
        bus.set(handler, event_handler);
        window.addEventListener(`${prefix}.${event_name}`, event_handler);
    };
    this.unsubscribe = (event_name, handler) => {
        let event_handler = bus.get(handler);
        window.removeEventListener(`${prefix}.${event_name}`, event_handler);
        bus.delete(handler);
    };
    this.publish = async (event_name, event_data) => {
        if (event_data === undefined) {
            event_data = null;
        }
        window.dispatchEvent(new CustomEvent(`${prefix}.${event_name}`, {detail: event_data}));
    };
};

export default EventBus;
